<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：機能一覧サブ画面
 *
 * 作成者：2021/11/25 ノア）虞
 * 最終修正者：2022/01/13 ノア）虞
 *
 -->
<template>
  <ttiDialog
    :isShow="isShow"
    @handelDisplay="onHandelDisplay"
    :manualKey="manualKey"
    marginTop="10vh"
    :title="$t('favorite.title')"
  >
    <template slot="body">
      <div class="tti-screen-body">
        <div class="content tti-favorite">
          <div class="con-left">
            <div class="menu-list"><tti-svg-icon icon-name="wo_011"></tti-svg-icon>{{ $t('menu.screens') }}</div>
            <div class="con-detail-left">
              <div v-for="(el, ind) in menuList" :key="ind">
                <div
                  class="child-title-left"
                  v-if="checkAllSubMenu(el)"
                  :class="{ bg: el.colorInd && el.colorInd % 2 == 0 }"
                >
                  <tti-svg-icon :icon-name="el.icon"></tti-svg-icon>
                  {{ el.menuName }}
                </div>
                <div v-for="(elChild, indChild) in el.children" :key="indChild">
                  <div
                    class="child-left tti-favorite-item"
                    :class="{ bg: elChild.colorInd && elChild.colorInd % 2 == 0 }"
                    v-if="userRole === UserRole.SYSTEM || userRole === elChild.role"
                  >
                    <div>{{ elChild.menuName }}</div>
                    <div class="icon-star" @click="onAddFavMenu(elChild)">
                      <tti-svg-icon
                        v-if="!elChild.isShow"
                        icon-name="wo_000"
                        v-tooltip="{
                          content: `${$t('favorite.addFavorite')}`,
                          placement: 'bottom-start',
                          delay: { show: 1000, hide: 0 }
                        }"
                      ></tti-svg-icon>
                      <tti-svg-icon
                        v-else
                        icon-name="wo_001"
                        v-tooltip="{
                          content: `${$t('favorite.removeFavorite')}`,
                          placement: 'bottom-start',
                          delay: { show: 1000, hide: 0 }
                        }"
                      ></tti-svg-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="con-right">
            <div class="title"><tti-svg-icon icon-name="wo_001"></tti-svg-icon>{{ $t('favorite.title') }}</div>
            <div class="con-detail-right">
              <div class="child-right">{{ $t('favorite.headDisplay') }}</div>
              <draggable tag="ul" group="favGroup" :list="favoriteMenuList" handle=".handle">
                <div v-for="(menuId, indRight) in favoriteMenuList" :key="menuId">
                  <div class="child-right tti-favorite-item">
                    <div>{{ getDefinitionName(menuMaster, menuId) }}</div>
                    <div class="icon-right">
                      <span
                        @click="onDeleteFavMenu(menuId, indRight)"
                        v-tooltip="{
                          content: `${$t('favorite.removeFavorite')}`,
                          placement: 'bottom-start',
                          delay: { show: 1000, hide: 0 }
                        }"
                      >
                        <tti-svg-icon icon-name="su_005"></tti-svg-icon>
                      </span>
                      <span
                        class="handle"
                        v-tooltip="{
                          content: `${$t('favorite.draggable')}`,
                          placement: 'bottom-start',
                          delay: { show: 1000, hide: 0 }
                        }"
                      >
                        <tti-svg-icon icon-name="su_024"></tti-svg-icon>
                      </span>
                    </div>
                  </div>
                  <div class="nav-bar_pickListItem" v-if="indRight === 2"><p></p></div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="foot">
      <div class="tti-bookmarks-foot">
        <div class="tti-bottom-left-area">
          <el-button
            class="tti-btn-default tti-btn-001"
            @click="onCancelButtonClick"
            v-tooltip="{
              content: `${$t('favorite.cancel')}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <tti-svg-icon icon-name="su_005"></tti-svg-icon>
            {{ $t('buttons.cancel') }}
          </el-button>
        </div>
        <div class="tti-bottom-right-area">
          <el-button
            class="tti-btn-default tti-btn-001"
            @click="onSaveButtonClick"
            v-tooltip="{
              content: `${$t('favorite.save')}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <tti-svg-icon icon-name="su_002"></tti-svg-icon>
            {{ $t('buttons.save') }}
          </el-button>
        </div>
      </div>
    </template>
  </ttiDialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import draggable from 'vuedraggable'
import { cloneDeep } from 'lodash'

import { dialog, common } from '@/store/modules'
import TtiDialog from '@/components/TtiDialog.vue'
import manualConfig from '@/config/manualConfig'
import { BookmarksParam } from '@/models/home'
import { getMenuConfig, getMenuMasterConfig } from '@/config'
import { MenuItem, MenuChild } from '@/models/home'
import { PageType, UserRole, BookmarksTargetType } from '@/commons/constants'
import { i18n } from '@/locales'
import HelperService from '@/service/helperService'
import { getBookmarks, updateBookmarks } from '@/store/apis'
import { msgBoxService } from '@/commons/services/msgBoxService'
import { localService } from '@/commons/services/localService'

@Component({
  name: 'home-fav',
  components: { TtiDialog, draggable }
})
export default class HOME_FAV extends Vue {
  /**
   * 機能一覧
   */
  screenList = getMenuConfig().screenList

  /**
   * 機能一覧汎用定義
   */
  menuMaster = getMenuMasterConfig().menuMaster

  /**
   * ユーザ種類
   */
  userRole = localService?.userInfo?.role || ''

  /**
   * ユーザ種類
   *
   * @readonly
   * @constant
   */
  UserRole = UserRole

  /**
   * 機能一覧
   */
  menuList: MenuItem[] = []

  /**
   * 気に入り
   */
  favoriteMenuList: string[] = []

  /**
   * 気に入り
   */
  favoriteMenuListCache: string[] = []

  /**
   * ダイアログボックスを表示するかどうかを取得する（画面用）
   *
   * @returns {boolean} ダイアログボックスを表示するかどうか（画面用）
   */
  get isShow(): boolean {
    this.initMenuConfig()
    if (dialog.isShowFavoriteDialog) {
      this.openDialogBefore()
    } else {
      // this.closeDialogAfter()
    }
    return dialog.isShowFavoriteDialog
  }

  /**
   * ダイアログボックスを表示するかどうかを設定する（画面用）
   *
   * @param {boolean} value ダイアログボックスを表示するかどうか（画面用）
   */
  set isShow(value: boolean) {
    dialog.setFavoriteDialogShow(value)
  }

  getDefinitionName = HelperService.getDefinitionName

  /**
   * メニュー情報初期化
   */
  initMenuConfig(): void {
    this.screenList = getMenuConfig().screenList
    this.menuMaster = getMenuMasterConfig().menuMaster
    this.judgeMenuShow()
  }

  /**
   * 機能一覧サブ画面の表示フラグを設定する
   *
   */
  judgeMenuShow(): void {
    if (localService.itpConnectValidFlag === '1') {
      this.screenList.forEach((el: MenuItem) => {
        if (el.icon === 'wo_007') {
          el.children.push({
            type: PageType.PAGE,
            menuId: 'connectCompanyMaster',
            menuName: i18n.t('menu.connectCompanyMaster') as string,
            role: UserRole.SYSTEM
          })
        }
      })

      this.menuMaster.push({
        code: 'connectCompanyMaster',
        value: i18n.t('menu.connectCompanyMaster').toString(),
        tip: i18n.t('menu.connectCompanyMasterTip').toString()
      })
    }
  }

  initMenuList(screenList: MenuItem[]): void {
    let colorIndCount = 1
    this.menuList = cloneDeep(screenList)
    this.menuList.forEach(menu => {
      menu.colorInd = colorIndCount++
      if (menu.children) {
        menu.children.forEach(child => {
          child.isShow = this.favoriteMenuList.indexOf(child.menuId as string) > -1
          child.colorInd = colorIndCount++
        })
      }
    })

    this.menuList.push({
      type: PageType.NOPAGE,
      menuName: i18n.t('menu.screens') as string,
      icon: 'wo_011',
      colorInd: colorIndCount++,
      children: [
        {
          type: PageType.POPUP,
          menuId: 'screenList',
          menuName: i18n.t('menu.screens') as string,
          role: UserRole.USER,
          isShow: this.favoriteMenuList.indexOf('screenList') > -1,
          colorInd: colorIndCount++
        }
      ]
    })
  }

  /**
   * 表示状態変更
   *
   * @param {boolean} value 表示状態
   * @returns {void}
   */
  onHandelDisplay(value: boolean): void {
    dialog.setFavoriteDialogShow(value)
  }

  /**
   * お好みメニューを追加する
   *
   * @param {MenuChild} elChild ニュー
   * @returns {void}
   */
  onAddFavMenu(elChild: MenuChild): void {
    elChild.isShow = !elChild.isShow

    if (elChild.isShow) {
      if (!this.correlationCheck()) {
        elChild.isShow = !elChild.isShow
        return
      }

      this.favoriteMenuList.push(elChild.menuId)
    } else {
      this.favoriteMenuList = this.favoriteMenuList.filter(item => item !== elChild.menuId)
    }
  }

  /**
   * お好みメニューを削除する
   *
   * @param {string} menuId ニュー
   * @param {number} index  インデックス
   * @returns {void}
   */
  onDeleteFavMenu(menuId: string, index: number): void {
    this.favoriteMenuList.splice(index, 1)
    this.menuList.forEach((childMenu, menuInd) => {
      childMenu.children?.forEach((item, childInd) => {
        if (item.menuId === menuId) {
          this.menuList[menuInd].children[childInd].isShow = false
        }
      })
    })
  }

  /**
   * 機能一覧サブ画面のマニュアルキーを取得
   *
   * @returns {string} 機能一覧サブ画面のマニュアルキー
   */
  get manualKey(): string {
    return manualConfig.route.homeFav
  }

  /**
   * 判断気に入り
   *
   * @returns {void}
   */
  checkFavorite(): void {
    this.menuList.forEach(menu => {
      if (menu.children) {
        menu.children.forEach(child => {
          if (this.favoriteMenuList.includes(child.menuId)) {
            child.isShow = true
          } else {
            child.isShow = false
          }
        })
      }
    })
  }

  /**
   * お気に入りを取得する。
   *
   * @returns {void}
   */
  async fetchBookmarksData(): Promise<void> {
    try {
      const bookmarks = await getBookmarks()

      this.favoriteMenuList = bookmarks.functionIdList ? bookmarks.functionIdList : []

      this.favoriteMenuListCache = cloneDeep(this.favoriteMenuList)

      this.checkFavorite()

      this.initMenuList(this.screenList)
    } catch (e) {
      this.$log.debug('HOME_FAV > fetchBookmarksData: e=', e)
      throw e
    }
  }

  /**
   * お気に入りを更新する。
   *
   * @returns {void}
   */
  async updateBookmarksData(): Promise<void> {
    try {
      const updateBookmarksParam: BookmarksParam = {
        target: BookmarksTargetType.MENU,
        functions: this.favoriteMenuList
      }

      await updateBookmarks(updateBookmarksParam)

      this.updateAfter()
    } catch (e) {
      this.$log.debug('HOME_FAV > updateBookmarksData: e=', e)
      throw e
    }
  }

  /**
   * お気に入りを更新後に実行したい操作。
   *
   * @returns {void}
   */
  updateAfter(): void {
    msgBoxService.info(i18n.t('messages.masterCommon.dataSaved').toString(), () => this.onHandelDisplay(false))

    common.setFavMenuList(this.favoriteMenuList)
  }

  /**
   * 取消ボタンをクリックした時の処理。
   *
   * @returns {void}
   */
  onCancelButtonClick(): void {
    if (!this.checkDataChanged()) {
      return
    }

    const confirmCallback = () => {
      this.favoriteMenuList = cloneDeep(this.favoriteMenuListCache)

      this.checkFavorite()
    }

    msgBoxService.confirm(i18n.t('messages.masterCommon.cancelConfirm').toString(), confirmCallback)
  }

  /**
   * 保存ボタンをクリックした時の処理。
   *
   * @returns {void}
   */
  onSaveButtonClick(): void {
    if (!this.checkDataChanged()) {
      msgBoxService.info(i18n.t('messages.masterCommon.dataNotChanged').toString())
      return
    }

    this.updateBookmarksData()
  }

  /**
   * リストが変更されましたかをチェックする。
   *
   * @returns {boolean} isChanged
   */
  checkDataChanged(): boolean {
    return HelperService.isTableDataChanged(this.favoriteMenuListCache, this.favoriteMenuList)
  }

  /**
   * ダイアログを開く前に実行したい操作。
   *
   * @returns {void}
   */
  openDialogBefore(): void {
    this.fetchBookmarksData()
  }

  /**
   * ダダイアログを閉じる後に実行したい操作。
   *
   * @returns {void}
   */
  // closeDialogAfter(): void {}

  /**
   * 相関チェックを行う
   *
   * @returns {boolean} 相関チェック結果
   */
  correlationCheck(): boolean {
    if (this.favoriteMenuList.length === 10) {
      msgBoxService.info(i18n.t('messages.masterCommon.maxCount', [i18n.t('favorite.title'), 10]).toString())
      return false
    }

    return true
  }

  /**
   * それが属するサブメニューが表示されているかどうかを確認する
   *
   * @param {MenuItem} menuItem 機能
   * @returns {boolean} 表示するかどうか
   */
  checkAllSubMenu(menuItem: MenuItem): boolean {
    if (!menuItem || !menuItem.children) return false

    let isShow = false
    for (const item of menuItem.children) {
      if (this.userRole === UserRole.SYSTEM || this.userRole === item.role) {
        isShow = true
        break
      }
    }

    return isShow
  }
}
</script>

<style scoped lang="scss">
.favorite ::v-deep.el-dialog__body {
  padding: 12px 24px;
  background: $C02;
  font-size: $FS01;
}

.tti-dialog-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tti-dialog-header-reference {
  position: absolute;
  right: 25px;
  top: -3px;
}

.tti-dialog-header-reference > .el-button {
  background-color: #e4eaff;
  padding: 0;
  color: #5d77ee;
}

::v-deep .tti-dialog-header-reference > .el-button > i {
  font-size: 25px;
}

.tti-screen-body {
  .content {
    display: flex;
    border-bottom: 1px solid #ccc;
    font-size: 20px;

    .con-left {
      flex: 6;

      .menu-list {
        display: flex;
        align-items: center;
      }

      .con-detail-left {
        background: #fff;
        font-size: $FS01;
        padding: 1px 0 8px 0;
        max-height: 63vh;
        overflow: hidden;
        overflow-y: auto;

        .child-title-left {
          display: flex;
          align-items: center;
          padding-left: 10px;
        }

        .child-title-left,
        .child-left {
          height: 32px;
          line-height: 32px;
        }

        .child-left {
          display: flex;
          justify-content: space-between;
          padding-left: 50px;

          .icon-star {
            padding-right: 5px;
            cursor: pointer;
          }
        }

        .bg {
          background: rgb(249, 249, 249);
        }
      }
    }

    .con-right {
      flex: 4;
      background: #fff;

      .title {
        display: flex;
        align-items: center;
        background: $C02;
      }

      .con-detail-right {
        background: #fff;
        font-size: $FS01;
        padding: 1px 10px 8px 10px;

        ul {
          margin: 0;
          padding: 0;
        }

        .child-right {
          display: flex;
          justify-content: space-between;
          height: 32px;
          line-height: 32px;

          .icon-right {
            span {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .nav-bar_pickListItem {
    height: 20px;
    display: flex;
    align-items: center;

    p {
      height: 1px;
      background-color: #ccc;
      padding: 0;
      margin: 0;
      width: 100%;
    }
  }
}

.tti-favorite .tti-favorite-item:hover {
  cursor: auto;
}

.tti-bookmarks-foot {
  display: flex;
  justify-content: space-between;
}

.tti-bottom-right-area button {
  margin-right: 0;
}
</style>
